/* eslint-disable @typescript-eslint/no-explicit-any */
import { Fine } from './types';
export const formatDateForInput = (date: Date) => {
  const pad = (num: number) => num.toString().padStart(2, '0'); // Pad single-digit numbers with a leading zero
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // Months are zero-based
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
export const getBackgroundColor = (status: string | null): string => {
  switch (status) {
    case 'F':
      return 'bg-red-500';
    case 'UNPAID':
      return 'bg-red-500';
    case 'P':
      return 'bg-yellow-500';
    case 'PAID':
      return 'bg-green-500';
    case 'WARNING':
      return 'bg-yellow-500';
    case 'S':
      return 'bg-green-500';
    case null:
    default:
      return 'bg-gray-300'; // Gray for null or undefined
  }
};
export const getPaymentStatusBackgroundColor = (
  status: string | null,
): string => {
  switch (status) {
    case 'UNPAID':
      return 'bg-red-500';
    case 'PAID':
      return 'bg-green-500';
    case null:
    default:
      return 'bg-gray-300'; // Gray for null or undefined
  }
};
export const processData = (data: Fine[] | undefined, filter: string) => {
  return data?.map((item) => {
    const date = new Date(item.dateCaptured);
    let displayDate;

    switch (filter) {
      case 'daily':
        // Show time for daily view
        displayDate = date.toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        });
        break;
      case 'weekly':
      case '2weeks':
        // Show date for weekly views
        displayDate = date.toLocaleDateString([], {
          month: 'short',
          day: 'numeric',
        });
        break;
      case 'monthly':
        // Show day and date for monthly view
        displayDate = date.toLocaleDateString([], {
          month: 'short',
          day: 'numeric',
          weekday: 'short',
        });
        break;

      case '3months': {
        // Show week number for 3-month view
        const weekNum = Math.ceil(
          (date.getTime() - new Date(date.getFullYear(), 0, 1).getTime()) /
            (1000 * 60 * 60 * 24 * 7),
        );
        displayDate = `Week ${weekNum}`;
        break;
      }

      case '6months':
        // Show month and week for 6-month view
        displayDate = date.toLocaleDateString([], {
          month: 'short',
          day: 'numeric',
        });
        break;
      case 'year':
        // Show month for yearly view
        displayDate = date.toLocaleDateString([], {
          month: 'long',
        });
        break;
      default:
        displayDate = date.toLocaleDateString();
    }

    return {
      dateCaptured: displayDate,
      amount: Number(item.amount),
    };
  });
};
export function getFirstTwoLetters(input: string, inputLength: number): string {
  if (input.length < inputLength) {
    throw new Error('Input string must have at least two characters.');
  }
  return input.slice(0, inputLength);
}
export const getFormattedValue = (
  array: [number, number | null][] | undefined,
  index: number,
  isCurrency: boolean = false,
): string => {
  const value = array?.[0]?.[index] ?? 0; // Default to 0 if null or undefined
  return isCurrency ? `KES ${value.toLocaleString()}` : value.toLocaleString();
};
export const getNestedValue = (obj: any, path: string) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj);
};
